import React from "react";

const ExtraSecton = () => {
  return (
    <div className="row py-5">
      <div className="col-lg-6 col-sm-12">
        <h2>Build your individual packages!</h2>
        <p>
          They enable you to decide on everything well before your trip, and you
          then don’t need to worry about things when you arrive – packages make
          your holiday easy. Would you prefer to have everything included? Or
          perhaps a free choice of restaurants? Anything goes! Finolhu will
          fulfill all yomeour wishes – not only during your stay but even before
          you leave home.
        </p>
        <button className="btn btn-info">Learn more</button>
      </div>
      <div className="col-lg-6 col-sm-12">
        <img
          src="https://www.finolhu.com/wp-content/uploads/elementor/thumbs/finolhu-maldives-seaside-collection-private-beach-dinner-p5y1mllnp1xdz7uvttn42hd25rdihn6xwr4u8vgn10.jpg"
          alt="not found"
        />
      </div>
    </div>
  );
};

export default ExtraSecton;
